var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingBag20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7502 5.99992H14.8335C15.5002 5.99992 16.0835 6.58325 16.0835 7.24992V17.2499C16.0835 17.9166 15.5002 18.4999 14.8335 18.4999H4.8335C4.16683 18.4999 3.5835 17.9166 3.5835 17.2499V7.24992C3.5835 6.58325 4.16683 5.99992 4.8335 5.99992H6.25016V5.58325C6.25016 3.49992 7.91683 1.83325 10.0002 1.83325C12.0835 1.83325 13.7502 3.49992 13.7502 5.58325V5.99992ZM10.0002 3.16659C8.5835 3.16659 7.50016 4.24992 7.50016 5.66659V6.08325H12.5002V5.66659C12.5002 4.24992 11.4168 3.16659 10.0002 3.16659ZM4.8335 17.2499H14.8335H14.9168V7.24992H13.8335V8.74992C13.8335 9.16659 13.5835 9.41659 13.1668 9.41659C12.7502 9.41659 12.5002 9.08325 12.5002 8.74992V7.24992H7.50016V8.74992C7.50016 9.08325 7.3335 9.41659 6.91683 9.41659C6.50016 9.41659 6.25016 9.08325 6.25016 8.74992V7.24992H4.8335V17.2499ZM7.50004 11.2499C7.50004 11.6181 7.20156 11.9166 6.83337 11.9166C6.46518 11.9166 6.16671 11.6181 6.16671 11.2499C6.16671 10.8817 6.46518 10.5833 6.83337 10.5833C7.20156 10.5833 7.50004 10.8817 7.50004 11.2499Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag20);
export default __webpack_public_path__ + "static/media/ShoppingBag-20.1b47e414.svg";
export { ForwardRef as ReactComponent };